import { MeasurementContext } from '@src/common/measurements/MeasurementContext';
import type { ReactNode } from 'react';
import { useState } from 'react';

export const MeasurementContextProvider = ({
  children,
  isMetricDefault = false,
}: {
  children: ReactNode;
  isMetricDefault?: boolean;
}) => {
  const [isMetric, setIsMetric] = useState<boolean>(isMetricDefault);

  return (
    <MeasurementContext.Provider value={{ isMetric, setIsMetric }}>
      {children}
    </MeasurementContext.Provider>
  );
};
